import { useI18n } from "@/context/I18nContext";

// Inline SVG flags — reliable across all browsers/OS (Windows has no flag emoji font).
function Flag({ code, className = "" }) {
  const cls = `inline-block w-5 h-3.5 rounded-[2px] ring-1 ring-black/20 shrink-0 ${className}`;
  switch (code) {
    case "pl":
      return (
        <svg viewBox="0 0 60 40" className={cls} aria-hidden="true">
          <rect width="60" height="20" fill="#fff" />
          <rect y="20" width="60" height="20" fill="#DC143C" />
        </svg>
      );
    case "de":
      return (
        <svg viewBox="0 0 60 40" className={cls} aria-hidden="true">
          <rect width="60" height="13.33" fill="#000" />
          <rect y="13.33" width="60" height="13.33" fill="#DD0000" />
          <rect y="26.66" width="60" height="13.34" fill="#FFCE00" />
        </svg>
      );
    case "uk":
      return (
        <svg viewBox="0 0 60 40" className={cls} aria-hidden="true">
          <rect width="60" height="20" fill="#0057B7" />
          <rect y="20" width="60" height="20" fill="#FFD700" />
        </svg>
      );
    case "en":
    default:
      return (
        <svg viewBox="0 0 60 30" className={cls} aria-hidden="true">
          <rect width="60" height="30" fill="#012169" />
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="3" />
          <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
          <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
        </svg>
      );
  }
}

export function LanguageSwitcher({ variant = "compact" }) {
  const { lang, setLang, langs } = useI18n();

  if (variant === "row") {
    return (
      <div className="flex gap-1.5 flex-wrap" data-testid="lang-switcher">
        {langs.map((l) => (
          <button key={l.code} type="button" data-testid={`lang-${l.code}`} onClick={() => setLang(l.code)}
            className={`px-2.5 py-1.5 rounded-md text-sm border flex items-center gap-1.5 transition-colors ${
              lang === l.code ? "border-cyan-500 bg-cyan-500/15 text-cyan-200" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>
            <Flag code={l.code} />{l.name}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-1.5" data-testid="lang-switcher">
      {langs.map((l) => (
        <button key={l.code} type="button" data-testid={`lang-${l.code}`} title={l.name} onClick={() => setLang(l.code)}
          className={`rounded-[3px] transition-all ${lang === l.code ? "ring-2 ring-cyan-500" : "opacity-50 hover:opacity-100"}`}>
          <Flag code={l.code} />
        </button>
      ))}
    </div>
  );
}
